import * as React from 'react';
import { memo } from 'react';
import styled from 'styled-components';
import { ArrowLeft } from 'lucide-react';

import { IPaletteRowItem } from './paletteTypes';
import { PaletteRow } from './PaletteRow';

interface IPaletteEntityActionsProps {
  title: string;
  backHint: string;
  items: IPaletteRowItem[];
  selectedIndex: number;
  onHover: (index: number) => void;
}

/** Drill-in view: the action list for the selected entity, with a back cue. */
export const PaletteEntityActions = memo<IPaletteEntityActionsProps>(
  ({ title, backHint, items, selectedIndex, onHover }) => (
    <>
      <Header>
        <ArrowLeft size={14} strokeWidth={2} />
        <HeaderTitle>{title}</HeaderTitle>
        <BackHint>{backHint}</BackHint>
      </Header>
      {items.map((item, index) => (
        <PaletteRow
          key={item.key}
          item={item}
          selected={index === selectedIndex}
          onHover={() => onHover(index)}
          onActivate={item.activate}
        />
      ))}
    </>
  ),
);

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px 6px;
  color: var(--k-fg-616e78);
`;

const HeaderTitle = styled.span`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--k-fg-616e78);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

const BackHint = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: var(--k-fg-c6ccd0);
`;
